import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { KdsBoard } from "@/features/kds/components/kds-board";
import { RestaurantGate } from "@/features/pos/components/restaurant-gate";
import { useActiveContext } from "@/features/pos/hooks/use-active-context";
import { useI18n } from "@/providers/i18n-provider";

function KdsPage() {
  const { t } = useI18n();
  const ctx = useActiveContext();
  return (
    <PageContainer maxWidth="5xl">
      <PageHeader title={t(msg`Kitchen display`)} />
      <RestaurantGate ctx={ctx}>{(c) => <KdsBoard org={c.org} branch={c.branch} />}</RestaurantGate>
    </PageContainer>
  );
}

export const kdsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/kds",
  component: KdsPage,
});
